import React      from 'react';
import classnames from 'classnames';
import RadioInput from './RadioInput';

const RadioLabel = (props) => {
  if (!props.label || props.label === '') {
    return null;
  }
  return (
    <label className="form-check-label" htmlFor={props.inputId}>{props.label}</label>
  );
};

const RadioComponent = props => (
  <div className={classnames('form-check', { 'form-check-inline': props.inline }, props.className)}>
    <RadioInput
      {...props}
      inputClassName={classnames('form-check-input', props.inputClassName)}
      inputId={props.inputId} />
    <RadioLabel {...props} />
  </div>
);


RadioComponent.defaultProps = {
  label: '',
  // inputClassName: 'form-check-input',
};

export default RadioComponent;
